export const MAIN_CLASS_NAME = 'connector-block';
